import { Suspense } from "react";
import { Provider } from "react-redux";
import { Outlet, useLocation } from "react-router-dom";

import { useMedplum } from "@medplum/react";

import AppShell from "@/app-shell";
import { Loading } from "@/components/Loading";
import store from "@/store";
import { isPublicAuthPathname } from "@/utils/medplum";

import Beacon from "./Beacon";

export function App(): JSX.Element {
  const medplum = useMedplum();
  const location = useLocation();
  const medplumIsLoading = medplum.isLoading();
  const isPublicAuthRoute = isPublicAuthPathname(location.pathname);

  // For the sign-in routes, we must not block rendering just because Medplum is still
  // resolving/syncing its persisted login state after token expiry.
  if (medplumIsLoading && !isPublicAuthRoute) {
    return <Loading />;
  }

  return (
    <Provider store={store}>
      <AppShell>
        <Suspense fallback={<Loading />}>
          <Beacon />
          <Outlet />
        </Suspense>
      </AppShell>
    </Provider>
  );
}
